import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getViewBonuses = (params) => {
    return axios.get(`${backendHost}/api/admin/bonuses/view`, {params});
};

export {
    getViewBonuses
}